import React, {useState, useEffect} from 'react';
import './styles/modals.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import { ApisProvider, ExtinctionData, ItemsData } from './feactures/dataProvider';
import { VideoLoader } from './UXHelper';
import { motion } from 'framer-motion';
import { LoadRewardExp } from './feactures/dataFetcher';


const urlIPFS = 'https://ipfs.io/ipfs/';

export const LoginModal = ({closeLogin, loginProvider}) => {

  return (
    <div className='modal_container'>
        <div className='modal_box'>
            <div className="close_container_modalunbox">
                <button className='btn_ close' onClick={closeLogin}><FontAwesomeIcon icon={faXmark}/></button>
            </div>
            <div className="info_body_modal_login">
                <h2 className='title_modal'>Please Select an Option</h2>
                <p className='subline_modal'>Here you can select with which wallet you want play.</p>
                <div className='cta_box_login'>
                    <button className='btn_ WCW' disabled onClick={() => loginProvider('WaxCloud')}>WAX CLOUD WALLET</button>
                    <button className='btn_ AW'  onClick={() => loginProvider('Anchor')}>ANCHOR WALLET</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export const UnboxingModal = ({ chestId, revealAction, onLoading, debugAction, debugfunc }) => {

    if(debugAction.bug){
        return(
            <div className='modal_container'>
                <div className="modal_box">
                    <div className='info_structurer_unboxingmodal'>
                        <h2>Blockchain Anomaly detected!</h2>
                        <p className='msg_cta'>Click on "Reload Data Again" button to try again get the process.</p>
                        <p className='msg_alert'>*DON'T RELOAD THE WEBSITE DURING THIS PROCESS*</p>
                        <h3 className='chest_id'>Chest ID: {chestId.id}</h3>
                    {onLoading
                    ?   <div className='d-flex justify-content-center'>
                            <div className="spinner-border ">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>   
                    :   <button onClick={() => {
                                        if(debugAction.double){
                                            const chest_id = debugAction.id_bug;
                                            const double = debugAction.double;
                                            debugfunc(chest_id, double);
                                        }
                                        else{
                                            const chest_id = debugAction.id_bug;
                                            debugfunc(chest_id);
                                        }
                                    }}>Reload Data Again</button>
                    }
                    </div>                  
                </div>
            </div>
        )
    }

    return (
        <div className='modal_container'>
            <div className="modal_box">
                <div className='info_structurer_unboxingmodal'>
                            <h2>Are you ready?</h2>
                            <p className='msg_cta'>Click on "Reveal" button. Good Luck!</p>
                            <p className='msg_alert'>*DON'T RELOAD THE WEBSITE DURING THIS PROCESS*</p>
                            <h3 className='chest_id'>Chest ID: {chestId.id}</h3>
                    {onLoading
                    ?   <div className='d-flex justify-content-center'>
                            <div className="spinner-border ">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>   
                    :   <button onClick={revealAction}>Reveal</button>
                    }
                </div>                
            </div>
        </div>
    )
}

export const RevealModal = ({ closeModal, assetData, isDouble }) => {

    const [showAnimation, setShowAnimation] = useState({
        show_1: false,
        show_2: false,
        show_single: false,
        
    })

    useEffect(() => {
      if(isDouble){
        setShowAnimation({
            show_1: true,
            show_2: false,
            show_single: false,
        });
      }else{
        setShowAnimation({
            show_1: false,
            show_2: false,
            show_single: true,
        });
      }
    
      return () => {
        
      }
    }, [])

    if(showAnimation.show_1){
        return (
          <div className='opener_video_container'>
            <VideoLoader url={assetData.videoReveal.full_size} url2={assetData.videoReveal.mobile_size} autoClose={() => setShowAnimation({
                show_1: false,
                show_2: true,
                show_single: false
            })}/>
          </div>
        )
    }

    if(showAnimation.show_2){
        return (
          <div className='opener_video_container'>
            <VideoLoader url={assetData.videoReveal_2.full_size} url2={assetData.videoReveal_2.mobile_size} autoClose={() => setShowAnimation({
                show_1: false,
                show_2: false,
                show_single: false
            })}/>
          </div>
        )
    }

    if(showAnimation.show_single){
        return (
          <div className='opener_video_container'>
            <VideoLoader url={assetData.videoReveal.full_size} url2={assetData.videoReveal.mobile_size} autoClose={() => setShowAnimation({
                show_1: false,
                show_2: false,
                show_single: false
            })}/>
          </div>
        )
    }

    if(isDouble){
        return(
            <div className='modal_container'>
                <div className="modal_box" style={{backgroundColor: '#191819'}}>
                    <div className="close_container_modalunbox">
                        <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                    </div>
                    <div className="box-info-reveal-double">
                        <div className="row">
                            <h2>Congratulations!</h2>
                        </div>
                        <div className="row">
                            <div className="col">
                                <video src={assetData.itemReveal} className='img-reveal' muted autoPlay loop/>
                            </div>
                            <div className="col">
                                <video src={assetData.itemReveal_2} className='img-reveal' muted autoPlay loop/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
                <div className='modal_container'>
                    <div className="modal_box" style={{backgroundColor: '#191819'}}>
                        <div className="close_container_modalunbox">
                            <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                        </div>
                        <div className="box-info-reveal">
                            <h2>Congratulations!</h2>
                            <video src={assetData.itemReveal} className='img-reveal' muted autoPlay loop/>
                        </div>
                    </div>
                </div>
    )
}

export const RevealRewardModal = ({ closeModal, assetData, isToken, noReward }) => {

    const [showAnimation, setShowAnimation] = useState(false)

    useEffect(() => {
      if(isToken || noReward){
        setShowAnimation(true);
      }
    
      return () => {
        
      }
    }, [])

    if(showAnimation){
        return (
          <div className='opener_video_container'>
            <VideoLoader url={'https://extinctionwars.com/assets/videos/visuals/openers/reward_reveal.mp4'} url2={'https://extinctionwars.com/assets/videos/visuals/openers/reward_reveal_responsive.mp4'} autoClose={() => setShowAnimation(false)}/>
          </div>
        )
    }

    if(noReward){
        return (
            <div className='modal_container'>
                <div className="modal_box">
                    <div className="close_container_modalunbox">
                        <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                    </div>
                    <div className="box-info-reveal-double">
                        <p>NOTHING IN THE BOX</p>
                    </div>
                </div>
            </div>
        )
    }

    if(isToken){
        return (
            <div className='modal_container'>
                <div className="modal_box">
                    <div className="close_container_modalunbox">
                        <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                    </div>
                    <div className="box-info-reveal-double">
                        <h2>Congratulations!</h2>
                        <p>You've won {assetData}</p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='modal_container'>
            <div className="modal_box">
                <div className="row justify-content-end mb-3">
                    <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                </div>
                <div className="box-info-reveal">
                    <h2>Congratulations!</h2>
                    <img src={urlIPFS + assetData.img} className='img-reveal' alt={assetData.name}/>
                    <h2>{assetData.name}</h2>
                </div>
            </div>
        </div>
    )
}

export const RevealRewardExpModal = ({ closeModal, userData, isRisky}) => {

    const [showAnimation, setShowAnimation] = useState(false);

    const [reward, setReward] = useState({
        isToken: false,
        amountToken: '',
        noReward: false,
        allLost: false,
        box: {},
        loading: false,
        error: false,
    })

    useEffect(() => {
        setShowAnimation(true);
    
      return () => {
        setShowAnimation(false);
      }
    }, []);

    const loadingData = () => {
        setReward({
            isToken: false,
            amountToken: '',
            noReward: false,
            allLost: false,
            box: {},
            loading: true,
            error: false,
        })
        setShowAnimation(false);
        uploadData();
    }

    const uploadData = async() => {
        LoadRewardExp(userData.username)
            .then(x => {
                if(x.result !== undefined){
                    if(Number(x.result) === ExtinctionData.ID_REWARD_ONYX_1){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template1,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_ONYX_2){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template2,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_ONYX_3){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template3,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_ONYX_4){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template4,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_NEO_COMMON){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template5,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_NEO_RARE){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template6,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_NEO_EPIC){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template7,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_NEO_LEGEND){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template8,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_CHAL_COMMON){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template9,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_CHAL_RARE){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template10,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_CHAL_EPIC){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template11,
                            noReward: false,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_CHAL_LEGEND){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template12,
                            noReward: false,
                            loading: false,
                            noReward_risky: false,
                            allLost: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_ONYX_13){
                        setReward({
                            isToken: true,
                            amountToken: x.templates.template13,
                            noReward: false,
                            loading: false,
                            noReward_risky: false,
                            allLost: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_NOTHING){
                        setReward({
                            isToken: false,
                            amountToken: '',
                            noReward: true,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_NOTHING && isRisky){
                        setReward({
                            isToken: false,
                            amountToken: '',
                            noReward: false,
                            loading: false,
                            allLost: true,
                            noReward_risky: false,
                            box: {},
                            error: false,
                        })
                    }
                    else if(Number(x.result) === ExtinctionData.ID_REWARD_NOTHING_2 && isRisky){
                        setReward({
                            isToken: false,
                            amountToken: '',
                            noReward: false,
                            allLost: false,
                            noReward_risky: true,
                            loading: false,
                            box: {},
                            error: false,
                        })
                    }
                    else{
                        const item_data = ItemsData.reward_boxes.find(y => Number(y.templateId) === Number(x.result));
                        setReward({
                            isToken: false,
                            amountToken: '',
                            noReward: true,
                            loading: false,
                            allLost: false,
                            noReward_risky: false,
                            box: {
                                img: item_data.img,
                                name: item_data.name,
                                rarity: item_data.rarity,
                            },
                            error: false,
                        })
                    }
                }
                else{
                    setReward({
                        isToken: false,
                        amountToken: '',
                        noReward: false,
                        allLost: false,
                        noReward_risky: false,
                        box: {},
                        loading: false,
                        error: true,
                    })
                }
            })
    }


    if(showAnimation){
        return (
          <div className='opener_video_container'>
            <VideoLoader url={'https://extinctionwars.com/assets/videos/visuals/openers/reward_reveal.mp4'} url2={'https://extinctionwars.com/assets/videos/visuals/openers/reward_reveal_responsive.mp4'} autoClose={() => loadingData()}/>
          </div>
        )
    }

    if(reward.loading){
        return (
            <div className='modal_container'>
                <div className="modal_box">
                    <div className='loading-box' style={{minWidth: '300px'}}>
                        <div className="spinner-border">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    if(reward.error){
        return (
            <div className='modal_container'>
                <div className="modal_box">
                    <div className='info_structurer_unboxingmodal'>
                        <h2>Blockchain Anomaly detected!</h2>
                        <p className='msg_cta'>Click on "Reload Data Again" button to try again get the process.</p>
                        <p className='msg_alert'>*DON'T RELOAD THE WEBSITE DURING THIS PROCESS*</p>
                        <button onClick={() => loadingData()}>Reload Data Again</button>
                    </div>                  
                </div>
            </div>
        )
    }

    if(reward.noReward){
        return (
            <div className='modal_container'>
                <div className="modal_box">
                    <div className="close_container_modalunbox">
                        <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                    </div>
                    <div className="box-info-reveal-double">
                        <p>No rewards on this expedition</p>
                    </div>
                </div>
            </div>
        )
    }

    if(reward.allLost){
        return (
            <div className='modal_container'>
                <div className="modal_box">
                    <div className="close_container_modalunbox">
                        <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                    </div>
                    <div className="box-info-reveal-double">
                        <p>The expedition failed and the suit and weapon were destroyed.</p>
                    </div>
                </div>
            </div>
        )
    }

    if(reward.noReward_risky){
        return (
            <div className='modal_container'>
                <div className="modal_box">
                    <div className="close_container_modalunbox">
                        <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                    </div>
                    <div className="box-info-reveal-double">
                        <p>The expedition failed, but the suit and weapon received no damage.</p>
                    </div>
                </div>
            </div>
        )
    }

    if(reward.isToken){
        return (
            <div className='modal_container'>
                <div className="modal_box">
                    <div className="close_container_modalunbox">
                        <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                    </div>
                    <div className="box-info-reveal-double">
                        <h2>Congratulations!</h2>
                        <p>You've won {reward.amountToken}</p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='modal_container'>
            <div className="modal_box">
                <div className="row justify-content-end mb-3">
                    <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                </div>
                <div className="box-info-reveal">
                    <h2>Congratulations!</h2>
                    <video src={reward.box.img} className='img-reveal' alt={reward.box.name}/>
                    <h2>{`${reward.box.name} ${reward.box.rarity}`}</h2>
                </div>
            </div>
        </div>
    )
}


export const CreatingTeamModal = ({ closeModal, idSlot, onCreate}) => {

    const [nameOfTeam, setNameOfTeam] = useState();
    const [message, setMessage] = useState('*Note: The team name must be at least 11 characters and up to a maximum of 18 characters (including spaces).');
    const [nameConfirmed, setNameConfirmed] = useState(false);
    const [nameCorrect, setNameCorrect] = useState(false);

    let nameFinal = '';

    const nameCapture = (evt) => {
        const name = evt.target.value;
        if (Number(name.length) >= 10 && Number(name.length) <= 18){
            nameFinal = name;
            setMessage('Team Name correct!');
            setNameCorrect(true);            
        }
        else if(Number(name.length) === 0){
            setMessage('*Note: The team name must be at least 11 characters and up to a maximum of 18 characters (including spaces).');
            setNameCorrect(false);
        }
        else{
            setMessage(`Team Name incorrect, try again.`);
            setNameCorrect(false);
        }
    }

    const nameConfirm = () => {
        setNameOfTeam(nameFinal);
        setNameConfirmed(true);
    }

    const sendAction = () => {
        onCreate(idSlot, nameOfTeam);
    }


    if(nameConfirmed){
        return(
            <div className='modal_container'>
                <div className="modal_box">
                    <div className="close_container_modalunbox">
                        <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                    </div>
                    <div className="modal-body">
                        <h2 className='title-modal2 text-center'>Congratulations!</h2>
                        <p className='text-center'>This is your new team:</p>
                        <h4 className='title-modal2 text-center'>"{nameOfTeam}"</h4>
                        <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                            <button onClick={() => sendAction()} className='alt_btn'>Create Now</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='modal_container'>
            <div className="modal_box">
                <div className="close_container_modalunbox">
                    <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                </div>
                <div className="modal-body">
                    <h2 className='title-modal2 text-center'>Set Your Team Name</h2>
                    <input type='text' id='nameOfTeam' aria-describedby='Type your team name here...' placeholder='Type your team name here...' name='nameOfTeam' value={nameOfTeam} onChange={nameCapture}/>
                    <div className={'form-text'}>{message}</div>
                    {nameCorrect &&
                        <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                            <button onClick={() => nameConfirm()} className='alt_btn'>Confirm Name</button>
                        </div>
                    } 
            </div>
            </div>
        </div>
    )
}

export const SetupTeamModal = ({ closeModal, idSlot, onLater}) => {
    return (
        <div className='modal_container'>
            <div className="modal_box">
                <div className="row justify-content-end mb-3">
                    <button className='btn_ close' onClick={closeModal}><FontAwesomeIcon icon={faXmark}/></button>
                </div>
                <div className="modal-body">
                    <h4 className='title-modal2 text-center'>Do you want setup your new team?</h4>
                    <div className='d-flex w-100 justify-content-around'>
                        <NavLink to={`editteam/${idSlot}`} className='btn_ btn-accept'>Yes, Go Now!</NavLink>
                        <button className='btn-cancel' onClick={onLater}>Later</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const VideoAnim = () => {
    
    return(
        <div className='modal_container'>
            <div className='animation_box'>
                <video src="/video/LOADER.mp4" onPause={() => console.log('se acabo')} autoPlay muted/>
            </div>
        </div>
    )
}

export const ModalNotify = (props) => {
    
    if(props.notify.error){
        return (
            <motion.div className='notify_structer'
            initial={{y: '-100px', opacity: 0}}
            animate={{y: 0, opacity: 1}}
            >
                <div className="close_container_nofity">
                    <button className='btn_ close' onClick={props.closeNotify}><FontAwesomeIcon icon={faXmark}/></button>
                </div>
                <div className="title_container_modalbtn">
                    <h2 className='title_modal_modabtn'>{props.notify.title}</h2>
                </div>
                <div className="info_footer_notify_box">
                    <p>{props.notify.msg}</p>
                </div>
            </motion.div>
        )
    }


    return (
        <motion.div className='notify_structer'
        initial={{y: '-100px', opacity: 0}}
        animate={{y: 0, opacity: 1}}
        >
            <div className="close_container_nofity">
                <button className='btn_ close' onClick={props.closeNotify}><FontAwesomeIcon icon={faXmark}/></button>
            </div>
            <div className="title_container_modalbtn">
                <h2 className='title_modal_modabtn'>{props.notify.title}</h2>
            </div>
            <div className="info_footer_notify_box">
                <p>{props.notify.msg}</p>
                <a ahref={`${ApisProvider.explorerProvider}${props.notify.txId}`} target='_blank' className='viewOnExplorerA'>{props.notify.txId}</a>
            </div>
        </motion.div>
    )
}

export const ModalBtn = (props) => {


    return (
        <div className='modal_container'>
            <div className='modal_box'>
                <div className="row justify-content-end mb-3">
                    <button className='btn_ close' onClick={() => props.closeModal('')}><FontAwesomeIcon icon={faXmark}/></button>
                </div>
                <div className="title_container_modalbtn">
                    <h2 className='title_modal_modabtn'>{props.title}</h2>
                </div>
                <div className="buttons_container_modalbtn">
                    <button onClick={() => props.action(props.part)}>Accept</button>
                    <button onClick={() => props.closeModal('')}>Cancel</button>
                </div>
            </div>
        </div>
    )
}

export const ModalBtnChildren = (props) => {

    return (
        <div className='modal_container'>
            <div className='modal_box'>
                <div className="close_container_btnmodalchildren">
                    <button className='btn_ close' onClick={() => props.closeModal('')}><FontAwesomeIcon icon={faXmark}/></button>
                </div>
                {props.children}
            </div>
        </div>
    )
}